import { ToolsPage } from './ToolsPage';

export const ToolsPageContainer = () => {
  return <ToolsPage />;
};
